import styled from "styled-components";
import Icon from "../../../../../../../base/icons/icon/index.js";
import { FlexMixin, FontMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
export const Travel = styled.div.withConfig({
    displayName: "styled__Travel",
    componentId: "sc-201691e8-0"
})`
	${FlexMixin({
    direction: 'column'
})}
	background-color: ${({ theme  })=>theme.bodyBgColor};
	padding: 16px;
`;
export const CardTravel = styled.div.withConfig({
    displayName: "styled__CardTravel",
    componentId: "sc-201691e8-1"
})`
	${FlexMixin({
    justify: 'space-between'
})}
	flex-flow: row nowrap;
	padding: 16px 0;
`;
export const CityInfo = styled.ul.withConfig({
    displayName: "styled__CityInfo",
    componentId: "sc-201691e8-2"
})`
	margin-bottom: 0;
	max-width: 20%;

	&.card-travel-origin {
		text-align: left;
	}

	&.card-travel-destination {
		text-align: right;
	}

	& > li.travel-date {
		${FontMixin({
    size: 'small',
    weight: 'regular',
    height: 'smaller'
})}
	}

	& > li.travel-hour {
		${FontMixin({
    size: 'base',
    weight: 'regular',
    height: 'base'
})}
	}

	& > li.travel-code {
		${FontMixin({
    size: 'medium',
    weight: 'bold',
    height: 'small'
})}
	}
`;
export const TransportInfo = styled.div.withConfig({
    displayName: "styled__TransportInfo",
    componentId: "sc-201691e8-3"
})`
	${FlexMixin({
    direction: 'column',
    justify: 'center',
    align: 'center'
})}
	${FontMixin({
    weight: 'regular'
})}
	color: ${({ theme  })=>theme.colors.grays.dark};
	flex-grow: 1;
`;
export const Divider = styled.div.withConfig({
    displayName: "styled__Divider",
    componentId: "sc-201691e8-4"
})`
	${FlexMixin({
    justify: 'center',
    align: 'center'
})}
	margin: 0 12px;
	position: relative;
	width: calc(100% - 24px);

	&:before {
		border-top: 1px dashed ${({ theme  })=>theme.colors.grays.base};
		content: '';
		left: 0;
		margin-top: -1px;
		min-width: 100%;
		position: absolute;
		top: 50%;
	}

	${Icon} {
		${FontMixin({
    size: 'larger'
})}
		background-color: ${({ theme  })=>theme.bodyBgColor};
		z-index: ${({ theme  })=>theme.zIndex.lowest};
	}
`;

//# sourceMappingURL=styled.js.map